
import { Hero } from "../components/home/Hero";
import { Vision } from "../components/home/Vision";
import { Features } from "../components/home/Features";
import { useState } from "react";
import { NewsletterForm } from "../components/home/NewsletterForm";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { Seo } from "@/components/Seo";

const Index = () => {
  const [showNewsletterForm, setShowNewsletterForm] = useState(false);

  const handleManifestClick = () => {
    const manifesteUrl = new URL('Manifeste.pdf', window.location.origin).href;
    window.open(manifesteUrl, '_blank');
  };

  const handleNewsletterButtonClick = () => {
    setShowNewsletterForm(true);
  };

  return (
    <div className="min-h-screen">
      <Seo title="Enfants de la République — Liberté, Égalité, Fraternité" description="Association citoyenne qui fait vivre les valeurs républicaines : signez la charte, découvrez le manifeste et rejoignez nos actions." path="/" />
      <Header />
      <Hero />
      
      {/* Newsletter Form Modal */}
      {showNewsletterForm && <NewsletterForm onSuccess={() => setShowNewsletterForm(false)} onClose={() => setShowNewsletterForm(false)} isModal={true} />}
      
      <Vision />
      <Features />
      <Footer />
    </div>
  );
};

export default Index;

